// 申请额度
export const RECEIVE_QUOTA = 0;
// 提现
export const APPLY_PRODUCT = 1;
// 还款
export const REPAYMENT = 2;
